import React from 'react';
import Box from '@mui/material/Box';

import { styledComponent } from 'src/utils/styled';
import Logo from '../../../other/Logo';
import IconButton from '../../../ui/IconButton';
import theme from 'src/utils/theme';

const Container = styledComponent(Box)<{ $isProApp: boolean }>`
    height: 4rem;
    width: 100vw;
    background-color: ${({ $isProApp }) => ($isProApp ? theme.palette.primary.main : theme.palette.background.paper)};
    display: flex;
    padding-left: 4rem;
    padding-right: 1.5rem;
    justify-content: space-between;
    align-items: center;
`;

interface Props {
    isProApp: boolean;
    onCloseClick: () => void;
}

export const FullscreenMapHeader: React.FC<Props> = ({ isProApp, onCloseClick }) => (
    <Container $isProApp={isProApp}>
        <Logo isProLogo={isProApp} height="3.2rem" />
        <IconButton
            color={isProApp ? 'inherit' : 'white'}
            sx={{ width: '3rem', height: '3rem' }}
            onClick={onCloseClick}
            iconProps={{
                name: 'Close',
                size: '1.5rem',
                color: isProApp ? theme.palette.background.paper : theme.palette.primary.main,
            }}
        />
    </Container>
);
